import {
    EXPORT_ORDER_DETAILS_FAIL,
    EXPORT_ORDER_DETAILS_SUCCESS,
    EXPORT_ORDER_FAIL,
    EXPORT_ORDER_SUCCESS,
    GET_ORDER_DETAILS_FAIL,
    GET_ORDER_DETAILS_SUCCESS,
    GET_ORDER_LISTING_FAIL,
    GET_ORDER_LISTING_SUCCESS,
    RESET_ORDER_ACTION_STATE,
    RESET_ORDER_STATE,
    UPDATE_ORDER_STATUS_FAIL,
    UPDATE_ORDER_STATUS_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
    orderListing: [],
    orderDetails: [],
    updateOrderStatus: [],
    exportOrderDocument: [],
    exportOrderDetailsDocument: [],
    error: [],
}

const Order = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ORDER_LISTING_SUCCESS:
            return {
                ...state,
                orderListing: action.payload
            }
        case GET_ORDER_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case GET_ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                orderDetails: action.payload
            }
        case GET_ORDER_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case UPDATE_ORDER_STATUS_SUCCESS:
            return {
                ...state,
                updateOrderStatus: action.payload
            }
        case UPDATE_ORDER_STATUS_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case EXPORT_ORDER_SUCCESS:
            return {
                ...state,
                exportOrderDocument: action.payload
            }
        case EXPORT_ORDER_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case EXPORT_ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                exportOrderDetailsDocument: action.payload
            }
        case EXPORT_ORDER_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_ORDER_ACTION_STATE:
            return {
                ...state,
                updateOrderStatus: [],
                exportOrderDocument: [],
                exportOrderDetailsDocument: [],
                error: [],
            }
        case RESET_ORDER_STATE:
            return {
                ...state,
                orderListing: [],
                orderDetails: [],
                updateOrderStatus: [],
                exportOrderDocument: [],
                exportOrderDetailsDocument: [],
                error: [],
            }
        default:
            return state
    }
}

export default Order
